import React, { createContext, useContext, useState, type ReactNode } from 'react';

type StudentMenuChoice = [preference: boolean | null, setPreference: (folded: boolean) => void];

const StudentMenuContext = createContext<StudentMenuChoice | undefined>(undefined);

/** Holds the student's fold choice above the routes, so it outlives the layout while a lesson is open. */
export const StudentMenuProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const choice = useState<boolean | null>(null);
  return <StudentMenuContext.Provider value={choice}>{children}</StudentMenuContext.Provider>;
};

export const useStudentMenuChoice = (): StudentMenuChoice => {
  const context = useContext(StudentMenuContext);
  if (!context) {
    throw new Error('useStudentMenuChoice must be used within StudentMenuProvider');
  }
  return context;
};
